import React from 'react';
import { Text, Colors } from 'library';
import { Grid, useMediaQuery } from '@mui/material';
import Phone from 'assets/images/eldercare/phone.png';
import theme from 'theme';

export default function EldercareHowItWorks({ ButtonGroup }: { ButtonGroup: React.FC }) {
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const howItWorks = [
        {
            title: 'Create Your Profile',
            text: "Tell us about your facility's staffing needs, preferences, and set your desired pay rate.",
        },
        {
            title: 'Advanced Matching',
            text:
                "Tandem's algorithm and hands on approach utilizes your preferences and job's requirements to pair you with a skilled STNA.",
        },
        {
            title: 'Your Stamp of Approval',
            text:
                "The STNA will work the confirmed shift(s). You'll be able to provide feedback, request the worker again, and even determine mutual permanent fit.",
        },
    ];
    return (
        <Grid
            xs={12}
            style={{ gap: 30, backgroundColor: Colors.lightTurq, padding: smDown ? 20 : 50 }}
            justifyContent="center"
            alignItems={smDown ? 'center' : undefined}
            container
            item
        >
            <Grid xs={12} lg={5} item container alignItems="center">
                <Grid item container style={{ gap: 20 }} alignItems="center">
                    <Text variant="display">How It Works</Text>
                    <ol type="1" style={{ display: 'flex', flexDirection: 'column', gap: 20, paddingInlineStart: 15 }}>
                        {howItWorks.map((step, index) => (
                            <li key={index}>
                                <Text bold inline>
                                    {step.title}
                                </Text>{' '}
                                <Text inline>{step.text}</Text>
                            </li>
                        ))}
                    </ol>

                    <ButtonGroup />
                </Grid>
            </Grid>
            <img
                src={Phone}
                alt="eldercare-phone"
                height={smDown ? 400 : 500}
                style={{ marginTop: smDown ? 40 : undefined, paddingLeft: 10 }}
            />
        </Grid>
    );
}
